<template>
    <h1 class="title title--intro" :aria-label="lines.map(el => el.text).join(' ')">
        <span data-v-line v-for="(line, key) in lines" :key="`intro-line-${key}`">

            <span
                v-for="(node, x) in lines[key].text"
                v-html="node == ' ' ? '&nbsp;' : node"
                :key="x" :ref="key + '-' + x"
                :class="{
                    'is-bright' : findHumanText(node, key, x),
                }"
            />
            <span data-v-space v-if="key < lines.length - 1">&nbsp;</span>

        </span>
    </h1>
</template>

<script>
// import { gsap } from 'gsap'

export default {
    name: 'IntroSlideTitle',
    props: ['lines'],
    data() {
        return {
            timer: 0
        }
    },
    mounted() {
        this.$emit('complete', 0)
        // var vm = this;
        // this.lines.map( (line, n) => {
        //     let pause = null
        //     let timeline = gsap.timeline({
        //         onComplete: () => {
        //             if ( n !== 3 || vm.timer < 100 ) return;

        //             vm.$emit('complete', 200)
        //         }
        //     });
        //     vm.toggleLine( n, line, timeline, !n ? pause : 0 )
        // })
    },
    methods: {
        findHumanText(c, line, index) {
            const words = ['human', 'connection']

            if ( !this.isMobile() )
            {
                if ( line == 1 )
                    return index >= this.lines[line].text.length - words[0].length ? [...words[0]].includes(c) : null
                else if ( line == 2 )
                    return index <= words[1].length ? [...words[1]].includes(c) : null

            } else if ( line === 3) {
                return index >= 0 && index < words[0].length ? [...words[0]].includes(c) : [...words[1]].includes(c)
            }
        },
        // findOrangeText(c, line, index) {
        //     const word = 'Imagine'
        //     return line == 0 && index <= word.length ? [...word].includes(c) : null
        // },
        // toggleLine( n, line, timeline ) {
        //     const letters = [...line.text]
        //     const time = letters.length * 20
        //     const delay = n * 10
            
        //     const M = this.isMobile()

        //     setTimeout(() => {
        //         const refs = letters.map((el, i) => this.$refs[`${n}-${i}`])
        //         timeline.to(refs, M ? .001 : .035, {
        //             opacity: 1,
        //             stagger: M ? 0 : .03,
        //             ease: 'circ'
        //         })

        //     }, M ? 0 : this.timer + delay)

        //     this.timer += time + delay
        // }
    }
}
</script>

<style lang="scss" scoped>
    /*.title*/ [data-v-line] {
        white-space: nowrap;
        > span {
            position: relative;
            // opacity: 0
        }
    }
</style>
